module.exports = __webpack_public_path__ + "static/media/tRokita.0d6889b7.jpeg";